import React from 'react';
import noop from 'lodash/noop';
import get from 'lodash/get';
import { Input, message, Modal } from 'antd';

const DashboardPrompt = ({
  okText,
  cancelText,
  content,
  needInput,
  title,
  key,
  visible,
  defaultLandingPageConfig,
  onOkFn,
  hidePrompt,
  createDashboard,
  updateDashboard,
  createDashboardByDashboardType,
  dashboardsUIStore,
  tabsStore,
  dashboards,
}) => {
  const { activeDashboardId } = dashboardsUIStore;
  const { tabsData = {} } = tabsStore;
  const { tmpPayload } = defaultLandingPageConfig;
  const {
    tempId,
    dashboardType,
  } = tmpPayload;
  const dashboardData = dashboards.find(e => `${e.id}` === `${tempId}`);
  const anotherCandidate = dashboards.find(e => `${e.id}` === `${activeDashboardId}`);
  const activePayload = tabsData[activeDashboardId]
    || dashboardData
    || anotherCandidate
    || {};
  const inputRef = React.useRef(null);
  const onApply = () => {
    const name = get(inputRef, 'current.input.value');
    if (needInput && !name) {
      message.error('Please enter dashboard name.');
      return;
    }
    if (needInput) {
      const {
        id,
        config,
        dashboardTypeId,
        unsaved,
      } = activePayload;
      const payload = {
        name,
        config: config || activePayload.dashboard,
        dashboardTypeId: dashboardTypeId || activePayload.type,
        isSaved: true,
      };
      if (unsaved) {
        if (activeDashboardId === -1) {
          const dashboardName = name;
          createDashboardByDashboardType(
            dashboardName,
            tmpPayload.dashboard,
            dashboardType,
            tempId,
            true,
            onOkFn,
          );
        } else {
          createDashboard(payload, id, true, onOkFn);
        }
      } else {
        updateDashboard(payload, id, true, onOkFn);
      }
    } else {
      // eslint-disable-next-line no-shadow
      const { id, name: dashboardName } = activePayload;
      const dashboardRealName = dashboardName || activePayload.title;
      onOkFn({ id, dashboard: dashboardRealName });
    }
    // onOkFn();
    hidePrompt();
  };

  const onCancel = () => {
    hidePrompt();
  };

  return (
    <Modal
      key={key}
      title={title}
      visible={visible}
      onOk={onApply}
      onCancel={onCancel}
      okText={okText || 'Confirm'}
      cancelText={cancelText || 'Discard'}
    >
      {content ? <p>{content}</p> : null}
      { needInput ? (
        <Input
          name="dashboard-name"
          placeholder="Enter dashboard name"
          defaultValue=""
          ref={inputRef}
        />
      ) : null }
    </Modal>
  );
};

DashboardPrompt.defaultProps = {
  okText: 'Save',
  cancelText: 'Cancel',
  needInput: false,
  content: '',
  title: 'dashboard',
  key: '',
  visible: false,
  hidePrompt: noop,
  onOkFn: noop,
  updateDashboard: noop,
  createDashboard: noop,
  createDashboardByDashboardType: noop,
  dashboardsUIStore: {},
  defaultLandingPageConfig: {},
  tabsStore: {},
  dashboards: [],
};

export default DashboardPrompt;
